




































import {
  defineComponent,
  useFetch,
  useContext,
  useRoute,
  ref
} from '@nuxtjs/composition-api';
import { usePartFinderStore } from '~/modules/part-finder/stores/partFinder';
import { storeToRefs } from 'pinia';
import { SfBreadcrumbs, SfHeading } from '@storefront-ui/vue';

export default defineComponent({
  name: 'Finders',
  components: {
    SfBreadcrumbs,
    SfHeading
  },
  setup() {
    const { i18n, localeRoute } = useContext();
    const store = usePartFinderStore();

    const breadcrumbs = [
      { text: i18n.t('Home'), link: localeRoute({ name: 'home' }).fullPath },
      { text: i18n.t('part-finder.spare-parts'), link: localeRoute({ name: 'part-finder' }).fullPath }
    ]

    const {
      finders,
      selectedFinder
    } = storeToRefs(store);

    const {
      loadFinders
    } = store;

    useFetch(async () => {
      if (!finders.value.length) {
        await loadFinders();
      }
    });

    return {
      breadcrumbs,
      finders,
      selectedFinder
    };
  }
});
